<template>
  <section class="message-container">
    <van-grid :border="false" :column-num="3">
      <van-grid-item @click="goList({ key:'comment' })">
        <van-image
          round
          width="46"
          height="46"
          fit="fill"
          :src="$cdnPath.img + 'message/plhh@2x.png'"
        />
        <h3 class="h2">评论/回复</h3>
      </van-grid-item>
      <van-grid-item @click="goList({ key:'ding' })">
        <van-image
          round
          width="46"
          height="46"
          fit="fill"
          :src="$cdnPath.img + 'message/dz@2x.png'"
        />
        <h3 class="h2">点赞</h3>
      </van-grid-item>
      <van-grid-item @click="goList({ key:'sixin' })">
        <van-image
          round
          width="46"
          height="46"
          fit="fill"
          :src="$cdnPath.img + 'message/sx@2x.png'"
        />
        <h3 class="h2">私信</h3>
      </van-grid-item>
    </van-grid>
    <!-- <van-cell is-link center title-class="pp" @click="goList({ key:'comment' })">
      <template #icon>
        <van-image round width="46" height="46" fit="fill" :src="$cdnPath.img + 'message/plhh@2x.png'"/>
      </template>
      <template #title>
        <h2 class="h2">评论/回复</h2>
      </template>
    </van-cell>
    <van-cell is-link center title-class="pp" @click="goList({ key:'ding' })">
      <template #icon>
        <van-image
          round
          width="46"
          height="46"
          fit="fill"
          :src="$cdnPath.img + 'message/dz@2x.png'"
        />
      </template>
      <template #title>
        <h2 class="h2">点赞</h2>
      </template>
    </van-cell>-->
    <van-cell-group title=" ">
      <van-cell
        center
        :title="item.title"
        :label="item.content"
        title-class="pp"
        v-for="(item, index) in list"
        :key="index"
        @click="goList(item)"
      >
        <template #icon>
          <van-image round width="46" height="46" fit="fill" :src="getImg(item.key)" />
        </template>
        <template #extra>
          <span class="time">{{item.time}}</span>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group title="信息反馈" v-if="message.length > 0">
      <van-swipe-cell v-for="(item, index) in message" :key="index">
        <van-cell center title="有影客服" :label="item.content" title-class="pp" @click="goList(item)">
          <template #icon>
            <van-image round width="46" height="46" fit="fill" :src="getImg('kefu')" />
          </template>
          <template #extra>
            <div style="line-height:1.1em;text-align:center;">
              <div class="time">{{item.time}}</div>
              <div class="time">{{item.isSolve ? '已解决' : ''}}</div>
            </div>
          </template>
        </van-cell>
        <template #right>
          <template v-if="item.isSolve == 0">
            <van-button square type="primary" class="button" @click="solve(item, 1)" text="已解决" />
          </template>
          <van-button square type="info" class="button" @click="solve(item, 0)" text="未解决" v-else />
          <van-button square type="danger" class="button" @click="delSolve(index)" text="删除" />
        </template>
      </van-swipe-cell>
    </van-cell-group>
  </section>
</template>

<script>
import { fetch, post } from "@/api/appRequest.js";
import API from "@/api/app.conf.js";
import { Dialog } from "vant";

export default {
  name: "message",
  components: {},
  data() {
    return {
      list: [],
      message: [],
    };
  },
  created() {
    fetch(API.U("notice", "/api/h5/v1/user/")).then((res) => {
      this.$dialog.loading.close();
      if (res.status_code == 200) {
        const data = JSON.parse(
          decodeURIComponent(res.data.replace(/\+/g, "%20"))
        );
        this.list = data.list;
        this.message = data.message;
      }
    });
  },
  methods: {
    solve(item, opt) {
      post(API.U("solve_operation", "/api/h5/v1/user/"), {
        isSolve: opt,
        ids: item.id,
      }).then((res) => {
        if (res.status_code == 200) {
          item.isSolve = opt;
        }
      });
    },
    delSolve(index) {
      Dialog.confirm({
        title: "确认删除吗？",
        message: "删除后无法恢复",
      })
        .then(() => {
          post(API.U("delete_notification", "/api/h5/v1/user/"), {
            ids: this.message[index].id,
          }).then((res) => {
            if (res.status_code == 200) {
              this.message.splice(index, 1)
              const data = JSON.parse(
                decodeURIComponent(res.data.replace(/\+/g, "%20"))
              );
              console.log(data)
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getImg(key) {
      let img = "message/yy@2x.png";
      switch (key) {
        case "push":
          break;
        case "tui":
          img = "message/jrgx@2x.png";
          break;
        case "notice":
          img = "message/xttz@2x.png";
          break;
        case "kefu":
          img = "message/yyxmse@2x.png";
          break;
      }
      return this.$cdnPath.img + img;
    },
    yy2c(a, p = new Object()) {
      let msg = {
        a: a,
        v: 1,
        p: p,
      };
      this.$yymd.yy2c(JSON.stringify(msg));
    },
    goList(item) {
      let p = {
        type: "1",
        url: location.origin + "/app/message/list/",
      };
      if (item.key) {
        p.url += item.key;
      } else {
        p.url += `${item.id}/${item.isSolve}`;
      }
      console.log(p);
      this.yy2c(100, p);
    },
  },
};
</script>

<style scoped>
.h2 {
  font-size: 1.2em;
  font-weight: 600;
  padding-top: 10px;
}
.pp {
  padding: 0 0.2rem;
}
.time {
  font-size: 0.8em;
  color: #999;
}
.button {
  height: 100%;
}
</style>
